import { useState, useEffect } from 'react';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CloseIcon from '@mui/icons-material/Close';
// Main Toast component
// Main Toast component
export function Toast({
    message = "Please complete all fields to proceed",
    subMessage = "This is a sub message",
    type = "error",
    visible = false,
    duration = 3000,
    onClose = () => { }
}) {
    const [isVisible, setIsVisible] = useState(visible);

    // Background color based on type
    const bgColor = {
        error: "bg-[#FEE9E7]",
        success: "bg-green-50",
        warning: "bg-yellow-50",
        info: "bg-blue-50"
    };

    // Text and icon color based on type
    const textColor = {
        error: "text-red-600",
        success: "text-green-600",
        warning: "text-yellow-600",
        info: "text-blue-600"
    };

    // Icon selector based on type
    const IconComponent = () => {
        switch (type) {
            case "error":
                return <ReportProblemIcon className={`${textColor[type]} !w-[14px] !h-[14px]`} />;
            case "success":
                return <div className={`${textColor[type]} font-bold text-lg`}>✓</div>;
            case "warning":
                return <ReportProblemIcon className={`${textColor[type]} w-[14px] h-[14px]`} />;
            case "info":
                return <div className={`${textColor[type]} font-bold text-lg`}>i</div>;
            default:
                return <ReportProblemIcon className={`${textColor[type]} w-[14px] h-[14px]`} />;
        }
    };

    useEffect(() => {
        setIsVisible(visible);

        if (visible && duration !== 0) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [visible, duration, onClose]);

    if (!isVisible) return null;

    return (
        <div className="fixed top-6 right-6 mx-auto w-fit max-w-lg px-4 z-50">
            <div className={`${bgColor[type]} border ${type === 'error' ? '!border-[#C00F0C]' : type === 'success' ? 'border-green-200' : type === 'warning' ? 'border-yellow-200' : 'border-blue-200'} rounded-lg p-4 shadow-md flex items-start justify-between`}>
                <div className="flex items-center">
                    <div className="flex-shrink-0">

                    </div>
                    <div className="ml-3">
                        <p className={`${textColor[type]} text-sm font-medium items-center`}>  <IconComponent /> {message}</p>
                        <p className='text-sm'>{subMessage}</p>
                    </div>
                </div>
                <button
                    type="button"
                    onClick={() => {
                        setIsVisible(false);
                        onClose();
                    }}
                    className="ml-1 flex-shrink-0 inline-flex text-gray-400 hover:text-gray-500 focus:outline-none"
                >
                    <CloseIcon className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
}